import { Icon } from '../../components/Icon';
import { FocusRootTimer } from './FocusRootTimer';
import { useFocusTimer } from './focus-context';

export function FocusHomeCard({ suggestedTask }: { suggestedTask?: string }) {
  const focus = useFocusTimer();
  const task = focus.mode === 'break' ? '休息片刻' : focus.task.trim() || suggestedTask || '选择今天最值得完成的一件事';
  const enter = () => {
    if (!focus.task.trim() && suggestedTask) focus.setTask(suggestedTask);
  };
  const resume = () => {
    enter();
    focus.start();
  };

  return <section className={`home-focus-card ornamental-card${focus.running ? ' is-running' : ''}`}>
    <div className="home-focus-copy">
      <header><span className="section-kicker"><span>今日专注</span><i>FOCUS · ROOT</i></span><em>{focus.running ? focus.mode === 'break' ? '正在休息' : '正在生长' : focus.progress > 0 ? '进度已保留' : '等待开始'}</em></header>
      <h2>留一段完整时间，<br />只做眼前这一件事。</h2>
      <p><Icon name={focus.mode === 'break' ? 'spark' : 'book'} /><b>{task}</b></p>
      <div className="home-focus-actions"><a className="home-focus-primary" href="/?view=focus" onClick={enter}>{focus.running ? '进入专注' : focus.progress > 0 ? '查看进度' : '开始一轮专注'}</a>{focus.running ? <button type="button" onClick={focus.pause}><Icon name="pause" />暂停</button> : focus.progress > 0 ? <button type="button" onClick={resume}><Icon name="play" />继续</button> : null}{focus.running || focus.progress > 0 ? <button className="home-focus-end" type="button" onClick={focus.finish}><Icon name="stop" />结束</button> : null}<span>今日 {focus.todayMinutes} 分钟 · {focus.todaySessions} 次</span></div>
    </div>
    <div className="home-focus-visual"><FocusRootTimer compact progress={focus.progress} remaining={focus.remaining} durationSeconds={focus.durationSeconds} mode={focus.mode} /><small>一念扎根，静候生长</small></div>
  </section>;
}
